import Vue from 'vue';
import Vuex from 'vuex';
import Auth from '@/store/modules/Auth';
import Actions from '@/store/modules/Stages';
import Properties from '@/store/modules/Properties';
import Agents from '@/store/modules/Agents';
import Admins from '@/store/modules/Admins';
import Customers from '@/store/modules/Customers';
import PropertyNotes from '@/store/modules/PropertyNotes';
import Settings from '@/store/modules/Settings';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		menuItems: [
			{
				url: '/residential',
				label: 'Residential',
				iconMenuItem: 'ico-grid',
				childItems: []
			},
			{
				url: '/commercial',
				label: 'Commercial',
				iconMenuItem: 'ico-buildings',
				childItems: []
			},
			{
				url: '/customers',
				label: 'Search Customers',
				iconMenuItem: 'ico-user-light',
				childItems: []
			}
		],
		agentItems: [
			{
				label: 'My Account',
				iconMenuItem: 'ico-user',
				url: 'MyAccountAgent'
			},
			// {
			// 	label: 'Settings',
			// 	iconMenuItem: 'ico-cog',
			// 	url: 'SettingsAgent'
			// },
			{
				label: 'Log out',
				iconMenuItem: 'ico-logout',
				url: ''
			}
		],
		adminItems: [
			{
				label: 'My Dashboard',
				iconMenuItem: 'ico-home',
				url: 'Properties'
			},
			{
				label: 'My Account',
				iconMenuItem: 'ico-user',
				url: 'MyAccountAdmin'
			},
			{
				label: 'Log out',
				iconMenuItem: 'ico-logout',
				url: ''
			}
		],
		superItems: [
			{
				label: 'My Dashboard',
				iconMenuItem: 'ico-home',
				url: 'Properties'
			},
			{
				label: 'My Account',
				iconMenuItem: 'ico-user',
				url: 'MyAccountAdmin'
			},
			// {
			// 	label: 'Settings',
			// 	iconMenuItem: 'ico-cog',
			// 	url: 'SettingsAdmin'
			// },
			{
				label: 'Log out',
				iconMenuItem: 'ico-logout',
				url: ''
			}
		],
		adminSideBar: [
			{
				iconMenuItem: 'ico-home',
				url: {
					name: 'Properties'
				},
				label: 'Properties',
				class: ''
			},
			{
				iconMenuItem: 'ico-bell',
				url: {
					name: 'VerifiedProperties'
				},
				label: 'Verified Notification',
				class: ''
			}
		],
		superSideBar: [
			{
				iconMenuItem: 'ico-home',
				url: {
					name: 'Properties'
				},
				label: 'Properties',
				class: ''
			},
			{
				iconMenuItem: 'ico-users',
				url: {
					name: 'CustomersAdmin'
				},
				label: 'Customers',
				class: ''
			},
			{
				iconMenuItem: 'ico-list',
				url: {
					name: 'Stages'
				},
				label: 'Stages',
				class: 'icon-sm'
			},
			{
				iconMenuItem: 'ico-user-full',
				url: {
					name: 'Agents'
				},
				label: 'Users',
				class: 'icon-sm'
			},
			{
				iconMenuItem: 'ico-bell',
				url: {
					name: 'VerifiedProperties'
				},
				label: 'Verified Notification',
				class: 'icon-sm'
			}
			// This (Agent Activity) was commented out because BE and CS were not done for this page
			// {
			// 	iconMenuItem: 'ico-profile',
			// 	url: {
			// 		name: 'AgentActivity'
			// 	},
			// 	label: 'Agent Activity',
			// 	class: 'icon-sm'
			// }
			// {
	
			// 	iconMenuItem: 'ico-cog',
			// 	url: {
			// 		name: ''
			// 	},
			// 	label: 'Settings',
			// 	classItem: 'is-sub-navigation',
			// 	class: 'icon-sm',
			// 	linkItemSub: [
			// 		{
			// 			url: {
			// 				name: 'SettingsAdmin'
			// 			},
			// 			label: 'IP Logs'
			// 		}
			// 	]
			// }
		]
	},

	mutations: {},

	actions: {},

	modules: {
		Auth: Auth,
		Actions: Actions,
		Properties: Properties,
		Agents: Agents,
		Admins: Admins,
		Customers: Customers,
		PropertyNotes: PropertyNotes,
		Settings: Settings
	},

	getters: {
		getMenuItems(state) {
			return state.menuItems;
		},
		getAgentItems(state) {
			return state.agentItems;
		},
		getAdminItems(state) {
			return state.adminItems;
		},
		getSuperItems(state) {
			return state.superItems;
		},
		getAdminSideBar(state) {
			return state.adminSideBar;
		},
		getSuperSideBar(state) {
			return state.superSideBar;
		}
	}
});
